export const fieldMap = [
  ["KeyIdentification", "tag"],
  ["Subjective", "subjective"],
  ["Objective", "objective"],
  ["Assessment", "assessment"],
  ["Plan", "plan"],
  ["Conclusion", "conclusion"],
  ["KeyIssues", "keyIssues"],
  ["AbnormalFindings", "abnormalFindings"],
  ["CustomerInstructions", "customerInstructions"],
  ["Reminders", "reminders"],
];

export const inpatFieldMap = [
  ["Summary", "summary"],
  ["Reminders", "reminders"],
  ["InstructionsStatus", "instructionsStatus"],
  ["AbnormalFindings", "abnormalFindings"],
  ["KeyIssues", "keyIssues"],
  ["RedFlags", "redFlags"],
  ["OtherUpdates", "otherUpdates"],
  ["Observation", "observation"],
];

export const surFieldMap = [
  ["PreSurgicalDocumentation", "preSurgicalDocumentation"],
  ["IntraSurgicalDocumentation", "intraSurgicalDocumentation"],
  ["PostSurgicalDocumentation", "postSurgicalDocumentation"],
  ["OwnerCommunication", "ownerCommunication"],
  ["AdditionalDocumentation", "additionalDocumentation"],
];
